import { render, staticRenderFns } from "./deleteActivities.vue?vue&type=template&id=6f5d994c&scoped=true"
import script from "./deleteActivities.vue?vue&type=script&lang=js"
export * from "./deleteActivities.vue?vue&type=script&lang=js"
import style0 from "./deleteActivities.vue?vue&type=style&index=0&id=6f5d994c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d994c",
  null
  
)

export default component.exports